import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import DeclarationWorkflow from "@components/form/declaration/DeclarationWorkflow";
import { useSubscriber } from "@hooks/query/useSubscriber";
import { useLevel0Resource } from "@hooks/query/useLevel0Resource";

const SubscriberCreateDeclaration = () => {
  const { t } = useTranslation();
  const { id: subscriberId = "", level0ResourceId = "" } = useParams();
  const { data: subscriber = {} } = useSubscriber(subscriberId);
  const { data: level0Resource = {} } = useLevel0Resource(level0ResourceId);

  return (
    <Layout
      permissions={["CreateDeclarations"]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: t("common.subscribers"),
          href: "/polestar/subscribers",
        },
        {
          label: subscriber.name,
          href: `/polestar/subscribers/${subscriberId}`,
        },
        {
          label: level0Resource.identifier,
          href: `/polestar/subscribers/${subscriberId}?level0ResourceId=${level0Resource.id}`,
        },
        {
          label: `${t("common.extraction_points")} ${t("common.and")} ${t(
            "common.meters"
          )}`,
          href: `/polestar/subscribers/${subscriber?.id}?level0ResourceId=${level0Resource?.id}&extractionPointId=random`,
        },
        {
          label: t("declaration.entering_read"),
        },
      ]}
      title={t("declaration.entering_read")}
      accountingPeriodLevel1ResourceId={subscriber.level1ResourceId}
    >
      <DeclarationWorkflow />
    </Layout>
  );
};

export default SubscriberCreateDeclaration;
